module.exports = __webpack_public_path__ + "media/images/episode6-be256c9d90f11401c18f8d8dd3ef0979.jpeg";